import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import MediaCard from "@/components/MediaCard";
import { MapPin, Tv, Radio, Loader2 } from "lucide-react";

export default function ProvinceDetail() {
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/provinces/${slug}`).then((r) => setData(r.data)).catch(() => {}); }, [slug]);

  if (!data) return <div className="flex justify-center py-24"><Loader2 className="animate-spin text-primary" size={32} /></div>;

  const tv = data.media.filter((m) => m.type === "tv");
  const radio = data.media.filter((m) => m.type === "radio");

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
      <div className="rounded-3xl border border-border bg-gradient-to-br from-rdcblue/10 to-rdcgold/10 p-6 sm:p-8 mb-6">
        <div className="flex items-center gap-2 text-rdcblue mb-1"><MapPin size={18} /> <span className="text-sm font-mono uppercase tracking-wider">Province</span></div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">{data.province.name}</h1>
        <div className="flex flex-wrap gap-4 mt-4 text-sm">
          <span className="flex items-center gap-1.5"><Tv size={15} className="text-rdcblue" /> {data.tv_count} télévision(s)</span>
          <span className="flex items-center gap-1.5"><Radio size={15} className="text-rdcgold" /> {data.radio_count} radio(s)</span>
        </div>
        {data.languages.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {data.languages.map((l) => <span key={l} className="rounded-md bg-card px-2 py-0.5 text-[11px] font-medium border border-border">{l}</span>)}
          </div>
        )}
      </div>

      {tv.length > 0 && (
        <section className="mb-8" data-testid="province-tv-section">
          <h2 className="font-heading font-bold text-xl mb-4 flex items-center gap-2"><Tv className="text-rdcblue" size={20} /> Télévisions</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">{tv.map((m, i) => <MediaCard key={m.id} media={m} index={i} />)}</div>
        </section>
      )}
      {radio.length > 0 && (
        <section className="mb-8" data-testid="province-radio-section">
          <h2 className="font-heading font-bold text-xl mb-4 flex items-center gap-2"><Radio className="text-rdcgold" size={20} /> Radios</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">{radio.map((m, i) => <MediaCard key={m.id} media={m} index={i} />)}</div>
        </section>
      )}
      {data.media.length === 0 && <p className="text-center text-muted-foreground py-16">Aucun média enregistré dans cette province pour le moment.</p>}
    </div>
  );
}
